"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = Checkmark;

var _Checkmark = require("@adobe/react-spectrum-workflow/dist/Checkmark");

var _icon = require("@react-spectrum/icon");

var _react = _interopRequireDefault(require("react"));

function Checkmark(props) {
  return /*#__PURE__*/_react.default.createElement(_icon.Icon, props, /*#__PURE__*/_react.default.createElement(_Checkmark.A4uCheckmark, null));
}